import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';

// Middleware
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import LocalForage from 'localforage';

// Constants
import { ENV } from '../constants/app';

// Reducers
import { reducer as formReducer } from 'redux-form';

import {
  accountReducer,
  adminReducer,
  collectionReducer,
  contractReducer,
  currencyReducer,
  customerReducer,
  detailsPanelReducer,
  errorsReducer,
  integrationsReducer,
  invoiceReducer,
  invoicingReducer,
  loginReducer,
  modalReducer,
  notificationsReducer,
  onBoardingReducer,
  paymentReducer,
  portalReducer,
  permsReducer,
  productsReducer,
  remindersReducer,
  reportsReducer,
  sidebarReducer,
  templateReducer,
  testReducer,
  themeReducer,
  topbarNotificationsReducer,
  dialogReducer,
  appVersionReducer,
  sourcePaymentsReducer,
  bulkOperationsReducer
} from '../redux/reducers/index';

let createStoreWithMiddleware;

const persistConfig = {
  key: 'primary',
  storage: LocalForage,
  whitelist: ['account', 'admin', 'form', 'perms', 'integrations', 'contracts', 'appVersion', 'bulkOperations']
}; // END config

const formPlugin = {
  LOG_IN_FORM: (state, action) => {
    switch (action.type) {
      case 'persist/REHYDRATE':
        return {};

      default:
        return state;
    }
  }
};

const forms = formReducer.plugin(formPlugin);

const rootReducer = combineReducers({
  account: accountReducer,
  admin: adminReducer,
  collection: collectionReducer,
  contracts: contractReducer,
  currency: currencyReducer,
  customers: customerReducer,
  detailsPanel: detailsPanelReducer,
  errors: errorsReducer,
  form: forms,
  info: testReducer,
  integrations: integrationsReducer,
  invoices: invoiceReducer,
  invoicing: invoicingReducer,
  login: loginReducer,
  modal: modalReducer,
  notifications: notificationsReducer,
  onBoarding: onBoardingReducer,
  payment: paymentReducer,
  perms: permsReducer,
  portal: portalReducer,
  products: productsReducer,
  reminders: remindersReducer,
  reports: reportsReducer,
  sidebar: sidebarReducer,
  templates: templateReducer,
  theme: themeReducer,
  topbarNotifications: topbarNotificationsReducer,
  dialog: dialogReducer,
  appVersion: appVersionReducer,
  sourcePayments: sourcePaymentsReducer,
  bulkOperations: bulkOperationsReducer
}); // END reducer

const reducer = persistReducer(persistConfig, rootReducer);

// Removes logger in prod build
if (ENV === 'production') {
  createStoreWithMiddleware = compose(applyMiddleware(promise, thunk))(createStore);
} else {
  createStoreWithMiddleware = compose(composeWithDevTools(applyMiddleware(promise, thunk)))(createStore);
} // END if

export const store = createStoreWithMiddleware(reducer);
export default store;
export const persistor = persistStore(store);

var localStorageEnabled = false;
try {
  localStorageEnabled = !!localStorage;
} catch (e) {
  console.error(e);
}

if (localStorageEnabled) window.onerror = localStorage.clear.bind(localStorage);



// WEBPACK FOOTER //
// ./src/app/store.js